<template>
  <div class="row mb-5 cart-progress">
    <div class="col-md-3 mb-3" v-for="prog in progress" :key="prog.id">
      <div
        class="text-center progress-text"
        :class="{ active: step === prog.id }"
      >
        {{ prog.step }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      progress: [
        { id: 0, step: '確認商品' },
        { id: 1, step: '填寫資料' },
        { id: 2, step: '完成訂購' }
      ]
    }
  },
  watch: {
    step (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.scrollToTop()
      }
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
